import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import AuthModal from '../components/AuthModal';

const AuthModalContext = createContext();

export const useAuthModal = () => {
  const context = useContext(AuthModalContext);
  if (!context) {
    throw new Error('useAuthModal must be used within an AuthModalProvider');
  }
  return context;
};

export const AuthModalProvider = ({ children }) => {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [authModalMode, setAuthModalMode] = useState('login');

  // Stabilere Funktionen
  const openAuthModal = useCallback((mode = 'login') => {
    setAuthModalMode(mode);
    setIsAuthModalOpen(true);
  }, []);

  const closeAuthModal = useCallback(() => {
    setIsAuthModalOpen(false);
  }, []);

  // Stabilisiertes Value-Objekt
  const value = useMemo(
    () => ({
      isAuthModalOpen,
      authModalMode,
      openAuthModal,
      closeAuthModal
    }),
    [isAuthModalOpen, authModalMode, openAuthModal, closeAuthModal]
  );

  return (
    <AuthModalContext.Provider value={value}>
      {children}
      {/* AuthModal wird immer gerendert, aber sichtbar per Prop gesteuert */}
      <AuthModal isOpen={isAuthModalOpen} onClose={closeAuthModal} defaultMode={authModalMode} />
    </AuthModalContext.Provider>
  );
};